import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

const Faq = (): JSX.Element => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const Section = (props: any): JSX.Element => {
    return (
      <div className={(props.gray ? 'bg-light-gray ' : '') + 'py-2'}>
        <Container>
          {props.children}
        </Container>
      </div>
    )
  }

  return (
    <div className="container-wbs">
      <Section gray={false}>
        <h3 className="mb-1">Was ist das Lernzeitkonto und wofür wird es angewendet? </h3>
        <p>
          Während Ihrer Teilnahme an der Qualifizierung gilt die Anwesenheitspflicht, da diese für einen erfolgreichen Abschluss eine wesentliche
          Bedingung ist. Das Lernzeitkonto dient der Erfassung Ihrer Abwesenheiten.
        </p>
      </Section>

      <Section gray={true}>
        <h3 className="mb-1 mt-3">Kann ich das Lernzeitkonto auch mobil nutzen?</h3>
        <p>Ja, das webbasierte Lernzeitkonto ist auch mobil, z.B. über Handy, nutzbar.</p>
      </Section>

      <Section gray={false}>
        <h3 className="mb-1 mt-3">Werden die Unterrichtszeiten ins Lernzeitkonto übertragen?</h3>
        <p>
          Ihre Anwesenheit wird automatisch durch den Login erfasst und ins Lernzeitkonto übertragen. Damit werden die Zeiten ab dem Login
          bis zum vertraglich vereinbarten Unterrichtsende im Lernzeitkonto erfasst.
        </p>
      </Section>

      <Section gray={true}>
        <h3 className="mb-1 mt-3">Wie lange kann ich die Eintragungen im Lernzeitkonto bearbeiten?</h3>
        <p>
          Bestätigte Abwesenheiten können nicht mehr bearbeitet werden. Bei späteren Änderungsbedarf wenden Sie sich an Ihre zuständige Standortbetreuer:in.
        </p>
      </Section>

      <Section gray={false}>
        <h3 className="mb-1 mt-3">Was mache ich bei einer Fehlzeit?</h3>
        <p>
          Die WBS TRAINING ist verpflichtet gegenüber Ihrem Kostenträger Ihre Fehlzeiten zu melden. Unter “Abwesenheit melden” informieren Sie Ihre
          zuständige Standortbetreuer:in über den Zeitraum (auch stundenweise Abwesenheit am Unterrichtstag) und Grund Ihrer Abwesenheit. Bitte laden
          Sie dazu ggf. einen digitalen Beleg hoch. Die Prüfung der Abwesenheiten erfolgt durch die Standortmitarbeiter:innen.
        </p>
        <p>Bei Fehlzeiten während Ihrer betrieblichen Lernphase (Praktikum) sind die Abwesenheiten über das Lernzeitkonto zu erfassen.</p>
      </Section>

      <Section gray={true}>
        <h3 className="mb-1 mt-3">Welche Abwesenheitsgründe werden von dem Kostenträger entschuldigt/anerkannt?</h3>
        <p>Folgende Fehlzeitengründe werden von den Kostenträgern anerkannt:</p>
        <ul>
          <li>Krankheit/Krankheit des Kindes (mit Arbeitsunfähigkeitsbescheinigung)</li>
          <li>Vorstellungsgespräche</li>
          <li>Eheschließung</li>
          <li>Ausübung öffentlicher Ehrenämter</li>
          <li>Geburt eines Kindes</li>
          <li>Trauerfall in der Familie</li>
          <li>Teilnahme an religiösen Festen</li>
          <li>Wahrnehmung von gerichtlichen oder polizeilichen Terminen</li>
        </ul>
      </Section>

      <Section gray={false}>
        <h3 className="mb-1 mt-3">Wie informiere ich im Falle einer Krankheit?</h3>
        <p>
          Jeder Krankheitstag ist mit einer Arbeitsunfähigkeitsbescheinigung ab dem ersten Tag zu belegen. Sie tragen Ihre Abwesenheit ins
          Lernzeitkonto ein.
        </p>
        <p>Während Ihrer betrieblichen Lernphase (Praktikum) ist zusätzlich der Betrieb zu informieren.</p>
      </Section>

      <Section gray={true}>
        <h3 className="mb-1 mt-3">Muss ich mich bei einer Fehlzeit trotzdem am Standort melden?</h3>
        <p>Nein, der Standort wird direkt über Ihren Eintrag im Lernzeitkonto informiert.</p>
      </Section>

      <Section gray={false}>
        <h3 className="mb-1 mt-3">Was passiert, wenn ich viele Fehlzeiten habe?</h3>
        <p>
          Bei wiederholt unentschuldigtem Fehlen werden Sie durch die zuständige Standortbetreuer:in zu einem
          Fehlzeitengespräch eingeladen. Bitte beachten Sie, dass in diesen Fällen auch Ihr Kostenträger darüber informiert wird. Weiteres
          unentschuldigtes Fehlen bzw. hohe Fehlzeiten können zum Abbruch der Qualifizierung führen. Bei längeren
          entschuldigten Fehlzeiten durch Krankheit wird eine Wiederholungsempfehlung an Ihren zuständigen Kostenträger abgegeben.
        </p>
      </Section>

      <Section gray={true}>
        <h3 className="mb-1 mt-3">Wer sind meine Ansprechpartner:innen für das Lernzeitkonto?</h3>
        <p>Ihre Standortbetreuer:in steht Ihnen bei Rückfragen zum Umgang mit dem Lernzeitkonto sehr gern zur Verfügung.</p>
        <p>
          Bei technischen Problemen wenden Sie sich bitte direkt an unseren IT-Support:{" "}
          <a href="mailto:IT.Support@wbstraining.de">IT.Support@wbstraining.de</a>.
        </p>
      </Section>

      <Section gray={false}>
        <h3 className="mb-1 mt-3">Was passiert mit meinen Daten nach Abschluss der Weiterbildung?</h3>
        <p>
          Wir speichern Ihre personenbezogenen Daten, solange es zur Erfüllung unserer gesetzlichen und vertraglichen Pflichten erforderlich ist.
          Sollte eine Speicherung der Daten für die Erfüllung vertraglicher oder gesetzlicher Pflichten nicht mehr erforderlich sein, werden Ihre
          Daten gelöscht, es sei denn, deren Weiterverarbeitung ist zur Erfüllung von Aufbewahrungspflichten erforderlich. Grundsätzliche
          Informationen zum Umgang mit personenbezogenen Daten bei WBS TRAINING AG sowie zu Ihren Rechten gemäß Art 13 DSGVO finden Sie unter{" "}
          <a rel="noopener noreferrer" target="blank" href="https://www.wbstraining.de/datenschutz/">
            https://www.wbstraining.de/datenschutz/
          </a>
          .
        </p>
      </Section>
    </div>
  );
};

export default Faq;
